/* eslint-disable no-unused-vars */
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import React from 'react';
import CustomPagination from '../CustomPagination';

export default function PaginatedControls({
  pagination,
  setPagination,
  packagesLength,
  searchValue,
  filters,
  handleSearch,
  fetchAllPackages
}) {
  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setPagination((prev) => ({
      ...prev,
      limit: newLimit,
      currentPage: 1
    }));

    if (searchValue || filters.length > 0) {
      handleSearch(1, newLimit);
    } else {
      fetchAllPackages(1, newLimit);
    }
  };

  const handlePageChange = (e, page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }));
    if (searchValue || filters.length > 0) {
      handleSearch(page, pagination.limit);
    } else {
      fetchAllPackages(page, pagination.limit);
    }
  };

  return (
    <Box
      mb={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      {/* Left: "Show up to" Dropdown */}
      <FormControl
        size="small"
        variant="outlined"
        style={{ marginTop: 8, minWidth: 160 }}
      >
        <InputLabel id="limit-select-label">Show up to</InputLabel>
        <Select
          labelId="limit-select-label"
          value={pagination.limit}
          label="Show up to"
          onChange={handleLimitChange}
        >
          {[5, 10, 20, 50].map((value) => (
            <MenuItem key={value} value={value}>
              {value} items
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Right: Pagination and Total Items */}
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body2" color="textSecondary">
          {packagesLength > 0 && (
            <>
              {(pagination.currentPage - 1) * pagination.limit + 1} -{' '}
              {Math.min(
                pagination.currentPage * pagination.limit,
                pagination.total
              )}{' '}
              of {pagination.total} items
            </>
          )}
        </Typography>

        <CustomPagination
          count={pagination.totalPages}
          page={pagination.currentPage}
          onChange={handlePageChange}
        />
      </Box>
    </Box>
  );
}
